import { render, staticRenderFns } from "./PlatformChoice.vue?vue&type=template&id=4cdd5ef0&scoped=true"
import script from "./PlatformChoice.vue?vue&type=script&lang=ts"
export * from "./PlatformChoice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdd5ef0",
  null
  
)

export default component.exports